import PropositionPageLexique from 'locales/types/containers/propositionPage/propositionPage';

export const propositionPageLexique: PropositionPageLexique = {
    headTitle: 'Proposition - Kolsquare',
    back: `Retour aux propositions`,
};

export default propositionPageLexique;
